import React, { useState } from 'react';

import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiButton from '@material-ui/core/Button';

function SelectGroup({ onSelect, releaseId, groups, currentGroup }) {
  const [currentSelection, setCurentSelection] = useState(currentGroup?.id);

  return (
    <div>
      <MuiSelect
        onChange={({ target: { value } }) => setCurentSelection(value)}
        label="Group"
        value={currentSelection ?? ''}>
        {groups.map(group => (
          <MuiMenuItem key={group.id} value={group.id}>
            {group.name}
          </MuiMenuItem>
        ))}
      </MuiSelect>
      <MuiButton disabled={!currentSelection} onClick={() => onSelect({ releaseId, groupId: currentSelection })}>
        {' '}
        Save Change{' '}
      </MuiButton>
    </div>
  );
}

export default SelectGroup;
